//#region src/components/ui/date-picker/locale/en_US.ts
var e = {
	selectDate: "Select Date",
	now: "Now",
	clear: "Clear",
	selectDateRange: "Select Date Range",
	startTime: "Start time",
	endTime: "End time",
	timeLabel: "{{hour}} hours {{minute}} minutes {{second}} seconds",
	noTimeSelected: "No time selected",
	timePanelAriaLabel: [
		"hour",
		"minute",
		"second"
	],
	rangeTime: "{{startTime}} - {{endTime}}"
};
//#endregion
export { e as datePickerLocale };

//# sourceMappingURL=en_US.js.map